import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalState } from '../store/types';

export type PatientSearchState = number[];

export const patientSearchSlice = createSlice({
  name: 'patient-search',
  initialState: [] as PatientSearchState,
  reducers: {
    addSearchedPatientId(
      state,
      action: PayloadAction<number | undefined | null>,
    ) {
      const newPatientId = action.payload;
      if (!newPatientId) return state;

      if (!state.includes(newPatientId)) {
        // three last searched patients are stored; the last patient is replaced when the list is full
        return [newPatientId, ...state.slice(0, 2)];
      }
      return state;
    },
  },
});

export const PatientSearchActions = patientSearchSlice.actions;

export const patientSearchSelector = (state: GlobalState) =>
  state.patientSearch;
